module.exports = __webpack_public_path__ + "img/log_out.0b87ba01.svg";